import "./Loader.css";
import React from "react";
import iconsTrans from "../../Assets/icons-trans.svg"

function template() {
  return (
    <div className="loader d-flex justify-content-center align-items-center h-100 w-100">
      <img src= {iconsTrans}/>
    </div>
  );
};

export default template;
